import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    options: {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      padding: [17, 0, 9],
      maxWidth: 278,
      [theme.breakpoints.up("mobile")]: {
        width: 556,
        maxWidth: "initial",
        padding: [34, 0, 16],
      },
    },
    shareButton: {
      padding: 0,
      margin: [0, 11, 11],
      display: "inline-block",
      textAlign: "center",
      background: "none",
      border: "none",
      cursor: "pointer",
      width: 64,
      [theme.breakpoints.up("mobile")]: {
        margin: [0, 24, 24],
        width: 102,
      },
    },
    image: {
      width: 48,
      marginBottom: 6,
      [theme.breakpoints.up("mobile")]: {
        width: 94,
        marginBottom: 12,
      },
    },
    name: {
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.large.fontSize,
      },
    },
  }),
  { name: "ShareModal-ShareOptions" },
);
